import PollingService from '@/utils/pollingService';
const { GY } = window;
/**
 *base64转 File 文件
 * urlData 为 base64
 **/
// import { getOcrData } from '@/api/common';
// import { getCity } from '@/api/common.js';
import router from '@/router';
import dayjs from 'dayjs';

export const base64ToFile = urlData => {
  const imgBase = `${urlData}`;
  return new Promise((resolve, reject) => {
    try {
      const arr = imgBase.split(',');
      if (arr.filter(i => i !== '').length > 1) {
        const mime = arr[0].match(/:(.*?);/)[1];
        const bytes = atob(arr[1]); // 解码base64
        let n = bytes.length;
        const ia = new Uint8Array(n);
        // eslint-disable-next-line no-plusplus
        while (n--) {
          ia[n] = bytes.charCodeAt(n);
        }
        const random1 = Math.floor(Math.random() * (0 - 10000)) + 10000;
        const curFile = new File([ia], random1, {
          type: mime,
        });
        resolve(curFile);
      } else {
        resolve(undefined);
      }
    } catch (error) {
      reject(error);
    }
  });
};
// http

// base64  byte[]  转为 excel文件格式 展示 luckyexcel 使用
export function changeToExcelFile(
  data,
  filename,
  type = 'application/vnd.ms-excel',
) {
  // decodeURIComponent(escape(window.atob(data)));

  const bstr = window.btoa(window.unescape(window.encodeURIComponent(data)));

  let n = bstr.length;

  const u8arr = new Uint8Array(n);
  while (n) {
    u8arr[n] = bstr.charCodeAt(n);
    n -= 1;
  }
  return new File([u8arr], filename, { type });
}

/**
 * 获取图片宽高
 * imgUrl 为 图片地址
 **/
export const getImgWidth = (imgUrl, width, height) => {
  return new Promise(resolve => {
    const img = new Image();
    let obj = {};
    img.onload = function () {
      // const msgKey = this.width < width - 20 || this.height < height - 19; //  减20解决浏览器兼容问题
      const msgKey = this.width < width || this.height < height;
      console.log('msgKey', msgKey, width, height);
      obj = {
        width: this.width,
        height: this.height,
        masg: msgKey ? `尺寸不小于${width}*${height}` : '',
      };

      resolve(obj);
    };
    img.src = imgUrl;
  });
};

/**
 * tree转map
 * 
 **/
export const treeToMap = (tree, map, keyName, valueName) => {
  for (let node of tree) {
    map.set(node[keyName], node[valueName]);
    if (node.children?.length) {
      treeToMap(node.children, map, keyName, valueName);
    }
  }
};

/**
 * 获取图片宽高
 * imgUrl 为 图片地址
 **/
export const getImgWidth2 = (imgUrl, width, height) => {
  return new Promise(resolve => {
    const img = new Image();
    let obj = {};
    img.onload = function () {
      // const msgKey = this.width < width - 20 || this.height < height - 19; //  减20解决浏览器兼容问题
      const msgKey = this.width > width || this.height > height;
      console.log('msgKey', msgKey, width, height);
      obj = {
        width: this.width,
        height: this.height,
        masg: msgKey ? `尺寸不大于${width}*${height}` : '',
      };

      resolve(obj);
    };
    img.src = imgUrl;
  });
};

/**
 * 获取图片大小不超过2M
 * file
 **/
export const beforeAvatarUpload = file => {
  const isLt2M = file.size / 1024 / 1024 < 2;
  return isLt2M;
};
// 一键复制 copyContent 为要复制的内容
export const copy = copyContent => {
  // 1. 创建并添加一个输入框元素(最后会销毁)
  const textareaEle = document.createElement('textarea');
  document.body.appendChild(textareaEle);
  // 2. 将需要复制的文本传入输入框, 并调用 select 方法, 选中输入框中文本
  textareaEle.value = copyContent;
  textareaEle.select();
  textareaEle.readOnly = 'readOnly';
  // 3. 调用复制选中文本的方法
  document.execCommand('copy');
  // 4. 销毁输入框
  document.body.removeChild(textareaEle);
};

/**
 * @description: js 转化为树形结构
 * @param {Array} data
 * @param {string} associatedField = parentId
 * @param {string} idField = id
 * @param {boolean} isParent = 是否追踪父节点
 * @param {boolean} noParentMode = 无父节点时是否添加到根节点
 * @return: 数组对象
 */
export const toTree = (
  data,
  associatedField = 'parent_id',
  idField = 'menu_id',
  isParent,
  noParentMode = true,
) => {
  if (!Array.isArray(data)) return [];

  // 删除 所有 children,以防止多次调用
  data.forEach(function (item) {
    // eslint-disable-next-line no-param-reassign
    delete item.children;
  });

  // 将数据存储为 以 id 为 KEY 的 map 索引数据列
  const map = {};
  data.forEach(function (item) {
    map[item[idField]] = item;
  });

  const val = [];
  data.forEach(function (item) {
    // 以当前遍历项，的pid,去map对象中找到索引的id
    const parent = map[item[associatedField]];
    // 如果找到索引，那么说明此项不在顶级当中,那么需要把此项添加到，他对应的父级中
    if (parent) {
      isParent && (item.parentNode = parent);
      (parent.children || (parent.children = [])).push(item);
    } else {
      // 如果没有在map中找到对应的索引ID,那么直接把 当前的item添加到 val结果集中，作为顶级
      // 如果ID 不为空，并且找不到对应的索引 ID，就根据noParentMode的值判断要不要作为顶级
      (['', null, undefined, 'root'].includes(item[associatedField]) ||
        noParentMode) &&
        val.push(item);
    }
  });
  return val;
};

/**
 * @description: js 树结构平铺
 * @param {Array} tree
 * @return: 数组对象
 */
export const opentree = tree => {
  const result = [];
  const flat = nodes => {
    if (nodes && nodes.length > 0)
      nodes.forEach(node => {
        result.push(node);
        flat(node.children);
      });
  };
  flat(tree);
  return result;
};

// pdf文件下载
export const fileLinkToStreamDownload = (url, fileName, type) => {
  const file = /(doc|docx|pdf|xlsx|xls|text|pdf|ppt|zip|rar|json|jpeg|png)/;
  const urlName = file.test(url);
  if (!urlName) {
    throw new Error('传入参数不合法,不是标准的文件链接');
  } else {
    const xhr = new XMLHttpRequest();
    xhr.open('get', url, true);
    xhr.setRequestHeader('Content-Type', `application/${type}`);
    xhr.responseType = 'blob';
    xhr.onload = function () {
      if (this.status === 200) {
        // 接受二进制文件流
        console.log(this);
        const blob = this.response;
        const blobUrl = window.URL.createObjectURL(blob);
        // 这里的文件名根据实际情况从响应头或者url里获取
        const a = document.createElement('a');
        a.href = blobUrl;
        a.download = fileName;
        a.click();
        window.URL.revokeObjectURL(blobUrl);
      }
    };
    xhr.send();
  }
};

// pdf文件下载2
export const fileDownload = (url, fileName) => {
  const file = /(doc|docx|pdf|xlsx|xls|text|pdf|ppt|zip|rar)/;
  const urlName = file.test(url);
  if (!urlName) {
    throw new Error('传入参数不合法,不是标准的文件链接');
  } else {
    getBlob(url, function (blob) {
      saveAs(blob, fileName);
    });
  }
};
function getBlob(url, cb) {
  const xhr = new XMLHttpRequest();
  xhr.open('GET', url, true);
  xhr.responseType = 'blob';
  xhr.onload = function () {
    if (xhr.status === 200) {
      cb(xhr.response);
    }
  };
  xhr.send();
}
function saveAs(blob, filename) {
  if (window.navigator.msSaveOrOpenBlob) {
    navigator.msSaveBlob(blob, filename);
  } else {
    const link = document.createElement('a');
    const body = document.querySelector('body');

    link.href = window.URL.createObjectURL(blob);
    link.download = filename;

    // fix Firefox
    link.style.display = 'none';
    body.appendChild(link);

    link.click();
    body.removeChild(link);

    window.URL.revokeObjectURL(link.href);
  }
}
//  uuid
export function getUUID(len, radix) {
  const chars =
    '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz'.split('');
  const uuid = [];
  let i;
  // eslint-disable-next-line no-param-reassign
  radix = radix || chars.length;
  if (len) {
    for (i = 0; i < len; i++) uuid[i] = chars[0 | (Math.random() * radix)];
  } else {
    let r;
    // eslint-disable-next-line no-multi-assign
    uuid[8] = uuid[13] = uuid[18] = uuid[23] = '-';
    uuid[14] = '4';
    for (i = 0; i < 36; i++) {
      if (!uuid[i]) {
        r = 0 | (Math.random() * 16);
        uuid[i] = chars[i === 19 ? (r & 0x3) | 0x8 : r];
      }
    }
  }
  return uuid.join('');
}

// 生产微信二维码
export function initWeChatCode(
  id = 'QR_code',
  href = 'data:text/css;base64,LmltcG93ZXJCb3ggLnFyY29kZSB7d2lkdGg6IDI0MHB4fQouaW1wb3dlckJveCAudGl0bGUge2Rpc3BsYXk6IG5vbmU7fQouaW1wb3dlckJveCAuaW5mbyB7ZGlzcGxheTogbm9uZTt9Ci5zdGF0dXNfaWNvbiB7ZGlzcGxheTogbm9uZX0KLmltcG93ZXJCb3ggLnN0YXR1cyB7dGV4dC1hbGlnbjogY2VudGVyO30=',
) {
  const ramdom = Math.random();
  new window.WxLogin({
    id,
    appid: 'wx770d4df6a89df71f',
    scope: 'snsapi_login',
    redirect_uri: encodeURI(`https://${window.location.hostname}/`),
    state: `${ramdom}`,
    href,
  });
}

// 图片ocr 识别
// export const ocrSearch = async ({ base64 = '', url = '', ocrtype = 0 }) => {
//   const pollingService = new PollingService(
//     '/org_manager_trpc/CommonSyncInterfaceNoLogin',
//   );

//   return new Promise((resolve, reject) => {
//     pollingService
//       .startPolling(getOcrData, {
//         image_base64: base64,
//         image_url: url,
//         ocr_type: ocrtype,
//       })
//       .then(res => {
//         resolve(res);
//       })
//       .catch(() => {
//         reject();
//       });
//   });
// };
/**
 * @description 数字和字符串 脱敏
 * @param {*} string 需要处理的字符串
 * @param {*} startEnd 前部分结束的位置
 * @param {*} endStart 后部分开始 如果为负数 则取后几位
 */
export function desensitize(string = '', startEnd = 3, endStart = 7) {
  if (!['string', 'number'].includes(typeof string)) {
    throw Error(
      'type error, The data processed by the desensitize function is not a string or number',
    );
  }
  const newEndStart =
    endStart >= 0 ? endStart : `${string}`.length - Math.abs(endStart);
  return `${`${string}`.substring(0, startEnd)}****${`${string}`.substring(
    newEndStart,
  )}`;
}
/**
 * @description 下载xl表格
 * @param {*} url 需要下载的链接
 * @param {*} name 名称
 */
export function download(url, name) {
  const xhr = new XMLHttpRequest();
  xhr.open('get', url);
  xhr.responseType = 'blob';
  xhr.onreadystatechange = function () {
    if (xhr.readyState === 4 && xhr.status === 200) {
      const blob = new Blob([xhr.response], { type: 'text/xls' });
      const csvUrl = URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = csvUrl;
      link.download = `${name}.xlsx`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(csvUrl);
    }
  };
  xhr.send();
}

// url 添加参数
export const urlAppendParams = (urlstr, paramObject) => {
  // 创建一个 URL 对象
  const url = new URL(urlstr);

  // 获取 URL 的查询参数
  const params = new URLSearchParams(url.search);

  // 添加新的参数
  for (const key in paramObject) {
    params.set(key, paramObject[key]);
  }

  // 更新 URL 的查询参数
  url.search = params.toString();
  return url.toString();
};

// 获取一个随机数
export function generateRandomString(len = 6) {
  const characters =
    'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
  let result = '';
  const charactersLength = characters.length;
  for (let i = 0; i < len; i++) {
    result += characters.charAt(Math.floor(Math.random() * charactersLength));
  }
  return result;
}
/**
 * 传入出生年月日计算到目前为止的年龄，用于OCR识别出的出生年月日
 * @param: ident为字符串身份证，type:true为1997/09/01,false为1997年09月09日
 * example：ident = '1997/8/4'或者,return age = 24岁 or 8月 or 8天
 */
export function uploadGetAge(ident, type) {
  let result;
  if (type) result = ident.split('/');
  else result = ident.replace(/[^0-9]/gi, '-').split('-');
  // 定义返回值
  let returnAge;
  // 获取输入框参数
  const birthYear = Number(result[0]);
  const birthMonth = Number(result[1]);
  const birthDay = Number(result[2]);
  // 获取当前时间
  const d = new Date();
  const nowYear = d.getFullYear();
  const nowMonth = d.getMonth() + 1;
  const nowDay = d.getDate();
  // 计算周岁年龄差
  if (nowYear === birthYear) {
    returnAge = 0; // 同年 则为0岁
  } else {
    const ageDiff = nowYear - birthYear; // 年之差
    if (ageDiff > 0) {
      if (nowMonth === birthMonth) {
        const dayDiff = nowDay - birthDay; // 日之差
        if (dayDiff < 0) {
          returnAge = ageDiff - 1;
        } else {
          returnAge = ageDiff;
        }
      } else {
        const monthDiff = nowMonth - birthMonth; // 月之差
        if (monthDiff < 0) {
          returnAge = ageDiff - 1;
        } else {
          returnAge = ageDiff;
        }
      }
    }
  }
  return returnAge ? returnAge : 1;
}

/**
 * 传入身份证判断到目前为止的年龄
 * @param: ident为字符串身份证
 * example：ident = '360727199709133000',return age = 24
 */
export function ageVerify(ident) {
  let yearBirth;
  let monthBirth;
  let dayBirth;
  if (ident.length === 15) {
    const orgBirthday = ident.substring(6, 12);
    // 获取出生年月日
    yearBirth = `19${orgBirthday.substring(0, 2)}`;
    monthBirth = orgBirthday.substring(2, 4);
    dayBirth = orgBirthday.substring(4, 6);
  } else if (ident.length === 18) {
    // 获取出生年月日
    yearBirth = ident.substring(6, 10);
    monthBirth = ident.substring(10, 12);
    dayBirth = ident.substring(12, 14);
  }
  // 获取当前年月日并计算年龄
  const myDate = new Date();
  const monthNow = myDate.getMonth() + 1;
  const dayNow = myDate.getDate();
  let age = myDate.getFullYear() - yearBirth;
  if (monthNow < monthBirth || (monthNow === monthBirth && dayNow < dayBirth)) {
    age = age - 1;
  }
  // 返回年龄
  return age;
}

// 地址拼接
export function addressTogether(province, city, area, address) {
  return province === city
    ? (city || '') + (area || '') + (address || '')
    : (province || '') + (city || '') + (area || '') + (address || '');
}

// 手机号隐藏4位
export function geTel(tel) {
  const reg = /^(\d{3})\d{4}(\d{4})$/;
  return tel.replace(reg, '$1****$2');
}

/**
 * 获根据cos返回的url来获取上传的文件或者图片的名称和后缀
 * @param: url
 * example: url = 'https://dev.cos.ap-shanghai.myqcloud.com/1668670689538%252F%253F%252F%25E8%25AF%2581%25E4%25B9%25A6.png'
 * return: {name: '证明', suffix: 'png'}
 */
export function getFileImageName(url) {
  if (url && url !== '') {
    let encodeKey = url.split('com');
    encodeKey.length === 1
      ? ([, encodeKey] = url.split('cn'))
      : ([, encodeKey] = encodeKey);
    // const decodeKey = decodeURIComponent(decodeURIComponent(encodeKey));
    const decodeKey = decodeURIComponent(encodeKey);
    const name = decodeKey.split('/').pop() || '.';
    const lastIndex = name.lastIndexOf('.');
    const suffix = name.slice(lastIndex + 1);
    const prefix = name.slice(0, lastIndex);
    return {
      name: prefix,
      suffix,
    };
  } else {
    return {};
  }
}

export function getFileShowName(url) {
  const data = getFileImageName(url || '');
  if (data && Object.keys(data).length > 0) {
    return `${data?.name || ''}.${data?.suffix || ''}`;
  } else {
    return '';
  }
}

// 判断两个相邻日期是否连续
export function continuousDate(list, ent, start) {
  const a = [];
  list.reduce((cur, next) => {
    Number(cur[ent].replaceAll('-', '')) ===
    Number(next[start].replaceAll('-', '')) - 1
      ? a.push(true)
      : a.push(false);
    return next;
  });
  return a.every(item => item);
}

// 清除所有cookie
// 清空cookie
export function clearCookie() {
  // eslint-disable-next-line no-useless-escape
  const keys = document.cookie.match(/[^ =;]+(?=\=)/g);
  if (keys) {
    // eslint-disable-next-line no-plusplus
    for (let i = keys.length; i--; ) {
      document.cookie = `${
        keys[i]
      }=0;path=/;domain=.gongyi.qq.com;expires=${new Date(0).toUTCString()}`; // 清除当前域名下的，例如 .m.kevis.com
      // document.cookie = `${keys[i]}=0;path=/;expires=${new Date(
      //   0,
      // ).toUTCString()}`; // 清除当前域名下的,例如：m.kevis.com
      // document.cookie = `${keys[i]}=0;path=/;domain=${
      //   document.domain
      // };expires=${new Date(0).toUTCString()}`; // 清除当前域名下的，例如 .m.kevis.com
      // document.cookie = `${
      //   keys[i]
      // }=0;path=/;domain=kevis.com;expires=${new Date(0).toUTCString()}`; // 清除一级域名下的或指定的，例如 .kevis.com
    }
  }
  console.log('已清除');
}

export function getcookie(cookiename) {
  const cookiestring = document.cookie;
  let start = cookiestring.indexOf(`${cookiename}= `);
  if (+start === -1)
    //   找不到
    return null;
  start += cookiename.length + 1;
  const end = cookiestring.indexOf('; ', start);
  if (end == -1) return unescape(cookiestring.substring(start));
  return unescape(cookiestring.substring(start, end));
}

/**
 * 脱敏重要信息: 如身份证号和电话号码
 * @param start:前面要显示的个数
 * @param end: 后面要显示的个数
 * @param num: 显示多少个*
 * @param value: 输入字符串
 * 例： 输入 start:3, end:4, num: 4, value:19189012345， @returns 输出 191****2345
 */
export const encrypt = (start, end, num, value) => {
  if (start >= value.length || end < 0) return '';
  const startValue = value.substr(0, start);
  const endValue = value.substr(value.length - end, value.length - 1);
  const numArr = [];
  for (let i = 0; i < num; i++) {
    numArr.push('*');
  }
  const numValue = numArr.join('');
  return startValue + numValue + endValue;
};
/**
 * 计算日期
 * @param n
 * @returns {String}
 */
export function getBeforeDate(strDate, n) {
  // strDate 为字符串日期 如:'2019-01-01' n为你要传入的参数，当前为0，前一天为-1，后一天为1
  const datt = strDate.split('-'); // 这边给定一个特定时间
  const newDate = new Date(datt[0], datt[1] - 1, datt[2]);
  // eslint-disable-next-line radix
  const befminuts = newDate.getTime() + 1000 * 60 * 60 * 24 * parseInt(n); // 计算前几天用减，计算后几天用加，最后一个就是多少天的数量
  const beforeDat = new Date();
  beforeDat.setTime(befminuts);
  const befMonth = beforeDat.getMonth() + 1;
  const mon = befMonth >= 10 ? befMonth : `0${befMonth}`;
  const befDate = beforeDat.getDate() - 1;
  const da = befDate >= 10 ? befDate : `0${befDate}`;
  const newDates = `${beforeDat.getFullYear()}-${mon}-${da}`;
  console.log(newDates);
  return newDates;
}

// 只保留数字
export function getNumber(str, arr) {
  if (arr?.includes(str)) {
    return '';
  }
  const numbers = str.replace(/\D/g, '');
  return numbers;
}
// 保留两位小数
export function getXiaoshu(val) {
  let item = val;
  if (val !== '' && val.substr(0, 1) === '.') {
    item = '';
  }
  item = item.replace(/^0*(0\.|[1-9])/, '$1'); // 粘贴不生效
  item = item.replace(/[^\d.]/g, ''); // 清除“数字”和“.”以外的字符
  item = item.replace(/\.{2,}/g, '.'); // 只保留第一个. 清除多余的
  item = item.replace('.', '$#$').replace(/\./g, '').replace('$#$', '.');
  item = item.replace(/^(-)*(\d+)\.(\d\d).*$/, '$1$2.$3'); // 只能输入两个小数
  if (item.indexOf('.') < 0 && item !== '') {
    // 以上已经过滤，此处控制的是如果没有小数点，首位不能为类似于 01、02的金额
    if (item.substr(0, 1) === '0' && item.length === 2) {
      item = item.substr(1, item.length);
    }
  }
  return item;
}

export function getCurYear() {
  var zoneOffset = 8;
  //算出时差,并转换为毫秒：
  var offset2 = new Date().getTimezoneOffset() * 60 * 1000;
  return GY.Util.time.formatDate(
    new Date().getTime() + offset2 + zoneOffset * 60 * 60 * 1000,
    'yyyy',
  );
}
// 获取方法的返回值
export function getFuncValue(func, ...params) {
  return typeof func === 'function' ? func(...params) : func;
}

// 防抖
export function debounce(func, wait) {
  let timeout;

  return function (...args) {
    clearTimeout(timeout);
    timeout = setTimeout(() => {
      func.apply(this, args);
    }, wait);
  };
}
export function paramsToUrl(url, _params = {}) {
  const { origin } = location;
  const urlObj = new URL(`${origin}${url}`);
  const params = new URLSearchParams(urlObj.search);

  for (const [key, value] of Object.entries(_params)) {
    params.set(key, value);
  }

  urlObj.search = params.toString();
  return urlObj.toString().slice(origin.length);
}
// 关闭当前标签页
export function closePage(timer = 0, params) {
  const closeBlink = localStorage.getItem('closeBlink');
  if (closeBlink) return;
  if (timer === true) {
    window.close();
    return;
  }
  setTimeout(() => {
    const blinkOrigin = localStorage.getItem('blinkOrigin');
    if (blinkOrigin) {
      localStorage.setItem('blinkOrigin', '');
      router.replace(paramsToUrl(blinkOrigin, params));
    } else {
      this.$router.back(-1);
      window.close();
    }
  }, timer);
}

// 下载文件
export function downloadFile(url, filename) {
  const xhr = new XMLHttpRequest();
  xhr.open('GET', url, true);
  xhr.responseType = 'blob';
  xhr.onload = function () {
    if (xhr.status != 200) {
      alert('下载异常！');
      return;
    }
    if (window.navigator.msSaveOrOpenBlob) {
      // IE
      navigator.msSaveBlob(xhr.response, filename);
    } else {
      const url = window.URL.createObjectURL(xhr.response);
      const a = document.createElement('a');
      a.setAttribute('href', url);
      a.setAttribute('target', '_blank');
      a.setAttribute('download', filename);
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
    }
  };
  xhr.send();
}

// 校验文件后缀
export function isFileExtensionValid(filename = '', accept = '') {
  const fileExtension = filename.split('.').pop().toLowerCase();
  const acceptExtensions = accept
    .split(',')
    .map(ext => ext.trim().toLowerCase().slice(1));
  return acceptExtensions.includes(fileExtension);
}

// 缓存的地址
// export async function getBankCity(province, city, area) {
//   if (province === '0' || province === '970000') {
//     return '全国';
//   }
//   let addr = '';

//   addr += province ? await getAddressByCode(0, province) : '';

//   const provinceId = cashMapCode[province]?.region_id;
//   addr += city ? await getAddressByCode(provinceId, city) : '';
//   const cityId = cashMapCode[city]?.region_id;
//   addr += area ? await getAddressByCode(cityId, area) : '';
//   return addr;
// }

// const cashMapCode = {};
// async function getAddressByCode(parent, no) {
//   let addr = cashMapCode[no];
//   if (addr) {
//     return addr.region_name;
//   }
//   parent = Number(parent);
//   const res = await getCity({ region_parent_id: parent, region_son_code: no });
//   res.forEach(t => {
//     cashMapCode[t.region_code] = t;
//   });
//   let name = cashMapCode[no]?.region_name;
//   if (!name) {
//     name = '';
//   }
//   return name;
// }

// 辅助函数：将十六进制或 RGB 颜色转换为 RGBA
export function convertToRgba(color, alpha) {
  if (typeof color !== 'string') {
    return `rgba(0, 0, 0, ${alpha})`; // 默认返回黑色
  }

  if (color.startsWith('#')) {
    // 处理十六进制颜色
    return hexToRgba(color, alpha);
  } else if (color.startsWith('rgb')) {
    // 处理 RGB 颜色
    return rgbToRgba(color, alpha);
  }

  return `rgba(0, 0, 0, ${alpha})`; // 默认返回黑色
}

// 将十六进制颜色转换为 RGBA
function hexToRgba(hex, alpha) {
  hex = hex.replace(/^#/, '');

  if (hex.length === 3) {
    hex = hex
      .split('')
      .map(char => char + char)
      .join('');
  }

  const bigint = parseInt(hex, 16);
  const r = (bigint >> 16) & 255;
  const g = (bigint >> 8) & 255;
  const b = bigint & 255;

  return `rgba(${r}, ${g}, ${b}, ${alpha})`;
}

// 将 RGB 颜色转换为 RGBA
function rgbToRgba(rgb, alpha) {
  return rgb.replace('rgb', 'rgba').replace(')', `, ${alpha})`);
}

/**
 * 去除对象空值
 * @param obj: 对象
 */
export const cleanObj = obj => {
  if (obj && typeof obj === 'object') {
    return Object.entries(obj).reduce((acc, [key, value]) => {
      if (value != null && value !== '') {
        acc[key] = value;
      }
      return acc;
    }, {});
  }
};

// 移除空参数
export function removeEmptyParams(obj) {
  const newObj = {};
  for (const key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      const value = obj[key];
      if (
        value !== null &&
        value !== undefined &&
        value !== '' &&
        !(Array.isArray(value) && value.length === 0)
      ) {
        if (typeof value === 'object' && !Array.isArray(value)) {
          const nestedObj = removeEmptyParams(value);
          if (Object.keys(nestedObj).length > 0) {
            newObj[key] = nestedObj;
          }
        } else {
          newObj[key] = value;
        }
      }
    }
  }
  return newObj;
}

// 校验手机号
export function isPhone(phone) {
  return /^1[3456789]\d{9}$/.test(phone);
}

// 校验身份证号
export function isIdCard(idCard) {
  return /^[1-9]\d{5}(19|20)\d{2}(0[1-9]|1[0-2])(0[1-9]|[12]\d|3[01])\d{3}(\d|X|x)$/.test(
    idCard,
  );
}

// 获取富文本中的图片地址
export function getRichTextImages(richText) {
  const imgURLs = [];
  const imgRegex = /<img [^>]*src="([^"]+)"[^>]*>/g;
  let match;

  while ((match = imgRegex.exec(richText)) !== null) {
    imgURLs.push(match[1]);
  }

  return imgURLs;
}

// 判断是全部是中文
export function isChineseString(str) {
  const pattern = /^[\u4e00-\u9fa5]+$/; // 匹配由中文字符组成的正则表达式
  return pattern.test(str);
}

// 判断日期范围是否为包含关系
export function dateIsBetween(dateList1, dateList2) {
  if (!dateList1?.length || !dateList2.length) return false;
  return (
    dateList1.every(d => dayjs(d).isBetween(...dateList2, 'd', '[]')) ||
    dateList2.every(d => dayjs(d).isBetween(...dateList1, 'd', '[]'))
  );
}

// js 数组去除另一个数组
export function arrayRemove(arr, target) {
  const new_set = new Set(arr);
  if (Array.isArray(target)) {
    for (const item of target) {
      new_set.delete(item);
    }
  } else {
    new_set.delete(target);
  }
  const new_arr = Array.from(new_set);
  return new_arr;
}

// 异步下载文件
export function asyncDownloadFile(requestFn, req, fileName, finallyFc) {
  const pollingService = new PollingService();
  pollingService
    .startPolling(requestFn, req)
    .then(res => {
      download(res.file_url, fileName);
    })
    .catch(err => {
      console.log(err);
    })
    .finally(() => {
      if (finallyFc && typeof finallyFc === 'function') {
        finallyFc();
      }
    });
}

export function findRoute(routes, path) {
  for (const item of routes) {
    if (item.id == path) {
      return item;
    }
    if (item.children) {
      const result = findRoute(item.children, path);
      if (result) {
        return result;
      }
    }
  }
  return '';
}

export function hidePhone(phone) {
  if (!phone) return '';
  return phone.replace(/(\d{3})\d{4}(\d{4})/, '$1****$2');
}

// 去掉字符串空格
export function trimValue(val) {
  if (Array.isArray(val)) {
    val.forEach((it, index) => {
      val[index] = trimValue(it);
    });
  } else if (Object.prototype.toString.call(val) === '[object Object]') {
    Object.keys(val).forEach(key => {
      val[key] = trimValue(val[key]);
    });
  } else if (typeof val === 'string') {
    val = val.trim();
  }
  return val;
}


// 按字计数。不要用表单 max：TDesign 的 max 把非 ASCII 字符算成 2，和输入框 maxlength 不一致。
export function maxChars(max, message) {
  return {
    validator: (val) => {
      const text = val == null ? '' : String(val);
      if ([...text].length > max) {
        return { result: false, message };
      }
      return { result: true };
    },
  };
}

export function requiredNoSpace(message = '必填项不能为空') {
  return {
    validator: (val) => {
      if (typeof val === 'string' && val.trim() === '') {
        return { result: false, message };
      }
      if (val === undefined || val === null || val === '') {
        return { result: false, message };
      }
      return { result: true };
    },
    trigger: 'blur'
  }
}

export function requiredNoEmoji() {
  return {
    validator: (val) => {
      // 匹配 emoji 的正则
      const emojiReg = /[\uD800-\uDBFF][\uDC00-\uDFFF]|[\u2600-\u27BF]|[\uFE0F]/g;
      if (emojiReg.test(val)) {
        return { result: false, message: '不支持输入表情符号' };
      }
      return { result: true };
    },
    trigger: 'blur'
  }
}

export function requiredOnlyChinese() {
   return {
    validator: (val) => {
      // 允许中文（\u4e00-\u9fa5）及新疆人名符号·（\u00B7）
      const reg = /^[\u4e00-\u9fa5\u00B7]+$/;
      // emoji检测（保留原逻辑）
      const emojiReg = /[\uD800-\uDBFF][\uDC00-\uDFFF]|[\u2600-\u27BF]|[\uFE0F]/g;
      if (!reg.test(val) || emojiReg.test(val)) {
        return { result: false, message: '仅支持中文，不能包含英文、数字、符号或表情' };
      }
      return { result: true };
    },
    trigger: 'blur'
  }
}

export function formatDate(str) {
  // 匹配 2008年5月14日 或 2008年05月14日
  const reg = /^(\d{4})年(\d{1,2})月(\d{1,2})日$/;
  const match = str.match(reg);
  if (!match) return '';
  const year = match[1];
  // 补零
  const month = match[2].padStart(2, '0');
  const day = match[3].padStart(2, '0');
  return `${year}-${month}-${day}`;
}